// Logical photo keys stay unchanged so attribution and position-specific alts remain intact.
export const STABLE_SITE_IMAGES = {
  "hardwood-install": "/images/site/walnut-rift-quartered-michigan-plank-floor-dining-area-novi-mi.webp",
  "dustless-refinish": "/images/site/refinished-hardwood-floor-empty-room.webp",
  "subfloor-leveling": "/images/site/spirit-level-concrete-subfloor-leveling-prep.webp",
  "about-craftsman": "/images/site/refinished-red-oak-floor-sunlit-corner-livonia-mi.webp",
  "family-photo": "/images/site/ed-malaski-family-1-wood-floors-owners.webp",
  "award-closeup": "/images/site/reclaimed-barnwood-floor-rubio-monocoat-farmington-hills-mi.webp",
  "showroom-samples": "/images/site/wood-species-sample-wall-livonia-design-center.webp",
  "product-spec-concierge": "/images/site/stair-nosing-inlay-detail-dark-stained-landing.webp",
  "staircase-renovations-hero": "/images/site/red-oak-staircase-dusky-walnut-floor-catwalk-view-farmington-hills-mi.webp",
  "hardwood-flooring-hub-hero": "/images/site/walnut-fas-8-inch-floor-wide-open-room-northville-mi.webp",
  "red-oak-refinish-livonia-dining": "/images/site/red-oak-refinished-floor-dining-room-livonia-mi.webp",
  "method-hard-shim": "/images/site/subfloor-hard-shim-plywood-low-spot-correction.webp",
  "method-joist-repair": "/images/site/floor-joist-repair-structural-dip-correction.webp",
  "custom-rift-quarter-walnut": "/images/site/michigan-plank-rift-quartered-walnut-floor-dining-novi-mi.webp",
  "custom-nature-white-oak": "/images/site/michigan-plank-european-white-oak-nature-novi-mi.webp",
  "custom-sand-white-oak": "/images/site/michigan-plank-white-oak-sand-plymouth-mi.webp",
  "custom-fireside-hickory": "/images/site/michigan-plank-hickory-fireside-livonia-mi.webp",
  "northville-walnut-grain-closeup": "/images/site/walnut-fas-8-inch-floor-wide-open-room-northville-mi.webp",
};

export function stableSiteImagePath(name) {
  return Object.prototype.hasOwnProperty.call(STABLE_SITE_IMAGES, name) ? STABLE_SITE_IMAGES[name] : undefined;
}